import Vue from 'vue'

let driversBaseUrl = 'http://3rvis.ir:8082'
const actions = {

  //user
  getUser({commit, getters,dispatch}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/get',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            dispatch('getMessages');
            resolve(res.data.answer)
          }

          reject(false)
        })
        .catch(err => {
          console.log(err)
          reject(false)
        })
    })
  },
  saveProfile({commit, getters}, payload) {
    return new Promise((resolve, reject) => {

      Vue.prototype.$http.post('user/student/update',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('UPDATE_USER_INFO', payload)
            resolve(res);
          }
          reject(res);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        })
    })
  },
  uploadProfileAvatar({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/photo/set',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            payload['url'] = res.data.answer;
            commit('PROFILE_AVATAR_UPLOADED', payload)
            resolve(payload['url'])
          }
          reject(false)
        })
        .catch(err => {
          console.log(err)
          reject(false)
        })
    })
  },
  getAllUsers({commit, getters}) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/getall',
        {
          requester: getters.userCredentials,
          request: {role: "all"}
        }
      )
        .then(res => {
          resolve(res.data.answer)
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
    });
  },


  //driver
  fetchDrivers({commit, getters}) {

    Vue.prototype.$http.post('user/getall',
      {
        requester: getters.userCredentials,
        request: {role: "driver"}
      }
    )
      .then(res => {
        commit('FETCH_DRIVERS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })

  },
  fetchDevices({commit}) {
    return new Promise((resolve, reject) => {
      fetch(`${driversBaseUrl}/api/devices`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": 'Basic ' + btoa(`admin:13adce#$`)
        },
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          commit('FETCH_DEVICES', res)
          resolve(true)
        })
        .catch(err => {
          reject(false)
        })
    })
  },
  saveDevice({commit, state}, payload) {
    let url, method;
    if (payload.id === -1) {
      url = `${driversBaseUrl}/api/devices`
      method = 'POST';
    } else {
      url = `${driversBaseUrl}/api/devices/` + payload.id
      method = 'PUT';
    }
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          "authorization": 'Basic ' + btoa(`admin:13adce#$`)
        },
        body: JSON.stringify(payload)
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          commit('DEVICE_SAVED', res)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    });
  },
  createDriver({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/driver/insert',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            payload['id'] = res.data.answer
            payload['role'] = 'DRIVER'
            //todo payload['schoolId'] = 5
            commit('DRIVER_CREATED', payload)
            resolve(res.data.answer);
          }
          reject(res);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        })
    })

  },
  updateDriverDevice({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/role/set',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          commit('DRIVER_UPDATED', payload)
          resolve(res);
        })
        .catch(err => {
          console.log(err.response.data)
          reject(err)
        })
    })
  },
  editDriver({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/driver/update',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('DRIVER_EDITED', payload)
            resolve(res);
          }
          reject(res);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        })
    })

  },
  deleteDriver({commit, getters}, payload) {
    Vue.prototype.$http.post('user/delete',
      {
        requester: getters.userCredentials,
        request: payload
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('DRIVER_DELETED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  getDeviceTrips({commit, getters}, params) {
    return new Promise((resolve, reject) => {
      fetch(`${driversBaseUrl}/api/reports/route?` + params, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": 'Basic ' + btoa(`admin:13adce#$`),
        },
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  async fetchDriverTasks({commit, getters, state}) {
    await Vue.prototype.$http.post('task/member/search',
      {
        requester: getters.userCredentials,
        request: {
          userId: state.AppActiveUser.id,
          role: 'DRIVER',
        }
      }
    )
      .then(res => {
        commit('FETCH_TASKS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })
  },

  //students
  fetchStudents({commit, getters}) {
    Vue.prototype.$http.post('user/getall',
      {
        requester: getters.userCredentials,
        request: {role: 'student'}
      }
    )
      .then(res => {
        commit('FETCH_STUDENTS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })
  },
  createStudent({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/student/insert',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            payload['id'] = res.data.answer
            payload['role'] = 'STUDENT'
            //todo payload['schoolId'] = 5
            commit('STUDENT_CREATED', payload)
            resolve(res.data.answer);
          }
          reject(res);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        })
    })

  },
  editStudent({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/student/update',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('STUDENT_EDITED', payload)
            resolve(res);
          }
          reject(res);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        })
    })

  },
  deleteStudent({commit, getters}, payload) {
    Vue.prototype.$http.post('user/delete',
      {
        requester: getters.userCredentials,
        request: payload
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('STUDENT_DELETED', payload)
        } else {
          // Vue.$vs.notify({title: 'مشکل در حذف دانش آموز', text: 'در صورتی که دانش آموز در کارگروهی عضو است، ابتدا او را از کار گروه خارج کنید', color: 'danger', position: 'top-center'})
          alert('در صورتی که دانش آموز در کارگروهی عضو است، ابتدا او را از کار گروه خارج کنید')
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  fetchStudentTasks({commit, getters, state}) {
    Vue.prototype.$http.post('task/member/search',
      {
        requester: getters.userCredentials,
        request: {
          userId: state.AppActiveUser.id,
          role: 'STUDENT',
        }
      }
    )
      .then(res => {
        commit('FETCH_TASKS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })
  },

  //task
  fetchTasks({commit, getters}) {

    Vue.prototype.$http.post('task/getall',
      {
        requester: getters.userCredentials,
        request: {role: "all"}
      }
    )
      .then(res => {
        commit('FETCH_TASKS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })

    // fetch(DOMAIN_ONE + 'task/getall', {
    //   method: 'POST',
    //   mode: 'no-cors',
    //   headers: {
    //     // 'Content-Type': 'application/json',
    //     // 'Accept': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     requester: getters.userCredentials,
    //     request: {role: "all"}
    //   })
    // })
    //   .then(response => {
    //     console.log(response)
    //     response.text()
    //   })
    //   .then(res => {
    //     console.log(res)
    //     // commit('FETCH_TASKS', res.data.answer)
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })

  },
  getTask({commit, getters, state}, id) {
    return new Promise((resolve, reject) => {
      if (id) {
        Vue.prototype.$http.post('task/get', {
          requester: getters.userCredentials,
          request: {taskId: id}
        })
          .then(res => {
            if (res.data.result) {
              let task = res.data.answer
              task['id'] = id
              commit('TASK_RECEIVED', task)
              resolve(true)
            }
          })
          .catch(err => {
            console.log(err)
            reject(false)
          })
      } else {
        //zero id will reset the taskInfo
        commit('RESET_TASK')
        resolve(true)
      }
    });
  },
  getTaskInfo({commit, getters, state}, id) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/getinfo', {
        requester: getters.userCredentials,
        request: {taskId: id}
      })
        .then(res => {
          if (res.data.result) {
            let taskInfo = res.data.answer
            taskInfo['id'] = id
            commit('TASK_INFO_RECEIVED', taskInfo)
            resolve(true)
          }
        })
        .catch(err => {
          console.log(err)
          reject(false)
        })
    });
  },
  stopLivePositions({commit}) {
    commit('STOP_LIVE_POSITIONS')
  },
  getPositions({commit, getters, state}, payload) {
    /*    Promise.all(payload.map(i =>
          fetch('http://3rvis.ir:8082/api/positions', {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Basic ' + btoa(`admin:13adce#$`),
              'Accept': 'http://localhost:8081'
            },
          }).then(resp => resp.json())
        )).then(res => {
          console.log(res)
          // commit('POSITIONS_RECEIVED', res)
        })*/
  },
  fetchPositions({commit}) {
    return new Promise((resolve, reject) => {
      fetch(`${driversBaseUrl}/api/positions`, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Basic ' + btoa(`admin:13adce#$`),
          'Accept': 'application/json'
        },
      })
        .then(res => res.json())
        .then(res => {
            commit('POSITIONS_RECEIVED', res)
            resolve(res)
          }
        )
        .catch(err => reject(err))
    })
  },
  saveTask({commit, getters}, payload) {
    let url = ''
    if (payload.id) {
      url = 'task/update'
    } else {
      url = 'task/create'
    }
    Vue.prototype.$http.post(url, {
      requester: getters.userCredentials,
      request: payload
    })
      .then(res => {
        if (res.data.result) {
          payload['id'] = payload.id ? payload.id : res.data.answer
          commit('TASK_SAVED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  deleteTask({commit, getters}, payload) {
    Vue.prototype.$http.post('task/delete',
      {
        requester: getters.userCredentials,
        request: payload
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('TASK_DELETED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  getTaskAutoRoutingStatus({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/autorouting/status',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          resolve(res.data.answer)
        })
        .catch(err => {
          reject(err)
          console.log(err)
        })
    })

  },


  //task info
  saveValidTimes({commit, getters, state}, payload) {
    let validTimes = [];
    Object.assign(validTimes, state.task.validTimes)

    if (payload.action === 'add') {
      validTimes.push(payload.item)
    } else {
      let index = validTimes.findIndex(i => {
        return i.dayNum === payload.item.dayNum &&
          i.hour === payload.item.hour &&
          i.min === payload.item.min
      })
      validTimes.splice(index, 1)
    }
    validTimes = validTimes.map(i => {
      return {
        day: i.dayNum,
        hour: Number(i.hour),
        min: Number(i.min),
      }
    })
    Vue.prototype.$http.post('task/validtime/set',
      {
        requester: getters.userCredentials,
        request: {
          id: payload.taskId,
          validTime: validTimes
        }
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('VALID_TIMES_SAVED', validTimes)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  createConstraint({commit, getters}, payload) {
    Vue.prototype.$http.post('task/constraints/add', {
      requester: getters.userCredentials,
      request: payload
    })
      .then(res => {
        if (res.data.result) {
          commit('CONSTRAINT_CREATED', {
            taskId: payload.taskId,
            type: payload.constraintType,
            userId1: payload.userId1,
            userId2: payload.userId2,
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  deleteConstraint({commit, getters}, payload) {

    Vue.prototype.$http.post('task/constraints/delete', {
      requester: getters.userCredentials,
      request: payload
    })
      .then(res => {
        if (res.data.result) {
          commit('CONSTRAINT_DELETED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  addTaskMember({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/member/add', {
        requester: getters.userCredentials,
        request: payload
      })
        .then(res => {
          if (res.data.result) {
            commit('TASK_MEMBER_ADDED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })
  },
  addTaskMembers({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/member/addlist', {
        requester: getters.userCredentials,
        request: payload
      })
        .then(res => {
          if (res.data.result) {
            commit('TASK_MEMBERS_ADDED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })
  },
  deleteTaskMember({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/member/delete', {
        requester: getters.userCredentials,
        request: {
          taskId: payload.taskId,
          userId: payload.userId,
        }
      })
        .then(res => {
          if (res.data.result) {
            commit('TASK_MEMBER_DELETED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })
  },
  startAutoRouting({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/autorouting/start', {
        requester: getters.userCredentials,
        request: payload
      })
        .then(res => {
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })

  },

  //service
  addServiceMember({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/service/member/add', {
        requester: getters.userCredentials,
        request: {
          serviceId: payload.serviceId,
          userId: payload.userId,
        }
      })
        .then(res => {
          if (res.data.result) {
            commit('SERVICE_MEMBER_ADDED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })

  },
  deleteServiceMember({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/service/member/delete', {
        requester: getters.userCredentials,
        request: [{
          serviceId: payload.serviceId,
          userId: payload.userId,
        }]
      })
        .then(res => {
          if (res.data.result) {
            commit('SERVICE_MEMBER_DELETED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })
  },
  assignServiceDriver({commit, state, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/service/member/add', {
        requester: getters.userCredentials,
        request: {
          serviceId: payload.serviceId,
          userId: payload.userId,
        }
      })
        .then(res => {
          if (res.data.result) {
            commit('SERVICE_DRIVER_ASSIGNED', payload)
          }
          resolve(res.data.result)
        })
        .catch(res => {
          console.log(res)
          reject(false)
        })
    })

  },
  createService({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/service/create',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('SERVICE_CREATED', {
              id: res.data.answer,
              name: payload.name,
              taskId: payload.taskId,
            })
            resolve(res);
          }
          reject(false)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })

  },
  updateService({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('task/service/update',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          commit('SERVICE_UPDATED', payload)
          resolve(res);
        })
        .catch(err => {
          console.log(err.response.data)
          reject(err)
        })
    })

  },
  deleteService({commit, getters}, payload) {
    Vue.prototype.$http.post('task/service/delete',
      {
        requester: getters.userCredentials,
        request: payload
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('SERVICE_DELETED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },

  //cohort
  fetchCohorts({commit, getters}) {
    Vue.prototype.$http.post('group/getall',
      {
        requester: getters.userCredentials
      }
    )
      .then(res => {
        commit('FETCH_COHORTS', res.data.answer)
      })
      .catch(err => {
        console.log(err)
      })

    // fetch(DOMAIN_ONE + 'task/getall', {
    //   method: 'POST',
    //   mode: 'no-cors',
    //   headers: {
    //     // 'Content-Type': 'application/json',
    //     // 'Accept': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     requester: getters.userCredentials,
    //     request: {role: "all"}
    //   })
    // })
    //   .then(response => {
    //     console.log(response)
    //     response.text()
    //   })
    //   .then(res => {
    //     console.log(res)
    //     // commit('FETCH_TASKS', res.data.answer)
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })

  },
  createCohort({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('group/insert',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            payload['id'] = res.data.answer
            commit('COHORT_CREATED', payload)
            resolve(payload)
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })

  },
  updateCohort({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('group/update',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('COHORT_UPDATED', payload)
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err.response.data)
          reject(err)
        })
    })

  },
  deleteCohort({commit, getters}, payload) {
    Vue.prototype.$http.post('group/delete',
      {
        requester: getters.userCredentials,
        request: payload
      }
    )
      .then(res => {
        if (res.data.result) {
          commit('COHORT_DELETED', payload)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  addUsersToCohorts({commit, getters}, {payload, context}) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('group/relation/insert',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('USERS_ADDED_TO_COHORTS', {payload, context})
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  removeUserFromCohort({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('group/relation/delete',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('USER_REMOVED_FROM_COHORT', payload)
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },

  //lock profile
  changeUserLock({commit, getters}, payload) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('user/lock',
        {
          requester: getters.userCredentials,
          request: payload
        }
      )
        .then(res => {
          if (res.data.result) {
            commit('USER_LOCK_CHANGED', payload)
            resolve(res);
          }
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },


  //get messages
  getMessages({commit, getters}){
    commit('UNREAD_MESSAGES_CHANGED', [])
    Vue.prototype.$http.post('message/retreive', {
      requester: getters.userCredentials,
      request: {"count": 20, "page": 0}
    }).then(res => {
      let messages = res.data.msgs.filter(i => !i.readTime)
      commit('UNREAD_MESSAGES_CHANGED', messages)
    })
  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({commit}, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
}

export default actions
